import { useContext, useEffect, useState } from "react";
import ProposalSlide from "../../../components/proposalSlideClient";
import ContentLayout from "../../../components/contentLayoutClient";
import { AppContext } from "../../../context/store";
import Cover from "../../../components/slides copy/cover";
import Introduction from "../../../components/slides copy/introduction";
import Investment from "../../../components/slides copy/investment";
import Proposal from "../../../components/slides copy/proposal";
import PlanOfAction from "../../../components/slides copy/planOfAction";
import AboutUs from "../../../components/slides copy/aboutUs";
import Contact from "../../../components/slides copy/contact";
import Reviews from "../../../components/slides copy/reviews";
import Impression from "../../../components/slides copy/impression";
import CorporateVideo from "../../../components/slides copy/corporateVideo";
import Closing from "../../../components/slides copy/closing";

const ProposalSlidesPage = () => {
  const Slides = {
    cover: Cover,
    introduction: Introduction,
    "requirement analysis": Proposal,
    "development approach": PlanOfAction,
    "development commercials": Investment,
    contact: Contact,
    reviews: Reviews,
   
  };

  const { selectedSlide, slidesName } = useContext(AppContext);
  const [index, setIndex] = useState(0);
  const [SelectedSlide, setSelectedSlide] = selectedSlide;
  const [animation, setAnimation] = useState ('animate-move-in-right')

  const Slide = Slides[SelectedSlide];
  


  const onNext = () => {
    const next = index + 1;
    setIndex(next < slidesName.length ? next : 0);
    setAnimation('animate-move-in-right');
  };

  const onPrev = () => {
    const prev = index - 1;
    setIndex(prev >= 0 ? prev : slidesName.length - 1);
    setAnimation('animate-move-in-left');
  };

  useEffect(() => setSelectedSlide(slidesName[index]), [index]);

  return (
    <ContentLayout onNext={onNext} onPrev={onPrev}>
      <ProposalSlide onNext={onNext} onPrev={onPrev}>
         <Slide slideAnimation={animation} />
      </ProposalSlide>
    </ContentLayout>
  );
};

export default ProposalSlidesPage;
